import {CacheDriverInterface, CacheManagerInterface} from './types'

export class CacheManager implements CacheManagerInterface {
  /**
   * Driver
   */
  private driver!: CacheDriverInterface

  /**
   * Set cache engine
   *
   * @param driver
   * @returns
   */
  setDriver(driver: CacheDriverInterface): CacheManagerInterface {
    this.driver = driver

    return this
  }

  /**
   * Get driver engine
   *
   * @returns
   */
  getDriver(): CacheDriverInterface {
    return this.driver
  }

  /**
   * Set value for the given key
   *
   * @param key
   * @param value
   * @param expireAfter
   */
  set(key: string, value: any, expireAfter?: number | undefined): CacheDriverInterface {
    this.driver.set(key, value, expireAfter)

    return this
  }

  /**
   * Get value by the given key
   *
   * @param key
   * @param defaultValue
   * @returns
   */
  get(key: string, defaultValue?: any) {
    return this.driver.get(key, defaultValue)
  }

  /**
   * Determine whether the cache has the given key
   *
   * @param key
   */
  has(key: string): boolean {
    return this.driver.has(key)
  }

  /**
   * Determine whether the cache has the given key
   *
   * @param key
   */
  remove(key: string): CacheDriverInterface {
    return this.driver.remove(key)
  }

  /**
   * set value parser when getting value
   * 
   * @param parser 
   * @returns 
   */
  setValueParser(parser: any): CacheDriverInterface {
    this.driver.setValueParser(parser)

    return this
  }

  /**
   * set value converter when setting value
   * 
   * @param converter 
   * @returns 
   */
  setValueConverter(converter: any): CacheDriverInterface {
    this.driver.setValueParser(converter)

    return this
  }

  /**
   * set prefix for the container cache key
   *
   * @param key
   * @returns
   */
  setPrefixKey(key: string): CacheDriverInterface {
    this.driver.setPrefixKey(key)

    return this
  }

  /**
   * Get prefix key
   */
  getPrefixKey(): string {
    return this.driver.getPrefixKey()
  }
}

const cacheManager = new CacheManager()

export default cacheManager
